import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

export function checkNeedThresholdConfirmation(
  requestType: RequestTypes,
  exceptionCode: string
): boolean {
  return (
    requestType === RequestTypes.Exception &&
    exceptionCode === 'Track Change due to revenue exception'
  )
}

export function checkIsThresholdConfirmedIfNeeded(
  requestType: RequestTypes,
  exceptionCode: string,
  isConfirmed: boolean
): boolean {
  return !checkNeedThresholdConfirmation(requestType, exceptionCode) || isConfirmed
}
